export function prettyFullName(first_name: string | undefined | null, last_name: string | undefined | null) {
  if (!first_name) {
    if (!last_name) {
      return 'N/A'
    }
    return last_name
  }

  if (!last_name) {
    return first_name
  }
  return `${first_name} ${last_name}`
}
